// Object.hasOwn 是 ES2022 运行时方法（Chrome 93+/Safari 15.4+），
// 旧 Android WebView 不支持；react-markdown / hast-util-to-jsx-runtime /
// refractor / es-toolkit 等依赖裸调此方法，触发 TypeError 整页崩溃。
// 此 polyfill 必须作为入口的第一个 import，先于其他模块求值。
if (!Object.hasOwn) {
  Object.defineProperty(Object, "hasOwn", {
    value: (obj: object, prop: PropertyKey) =>
      Object.prototype.hasOwnProperty.call(obj, prop),
    configurable: true,
    writable: true,
  });
}
